import React from 'react';
import styled from 'styled-components';

const Badge = styled.span`
  background-color: #f0f0f0;
  border-radius: 16px;
  padding: 6px 12px;
  font-size: 13px;
  white-space: nowrap;
`;

interface PortalItem {
  label: string;
  total: number;
}

interface Props {
  data: PortalItem[];
}

const PortaisOverview = ({ data }: Props) => {
  return (
    <div>
      <h5 className="mb-3 d-flex align-items-center">Por Portais</h5>
      {data.length > 0 ? (
        <div className="d-flex flex-wrap" style={{ gap: 8 }}>
          {data.map((item) => (
            <Badge key={item.label}>
              {item.label} <strong>{item.total}</strong>
            </Badge>
          ))}
        </div>
      ) : (
        <p className="text-muted mb-0">Não localizamos os portais</p>
      )}
    </div>
  );
};

export default PortaisOverview;
